import { IResponseModel } from "../../IResponseModel";

export class AddServerResponse implements IResponseModel {
}